import React from "react";

const CARDS = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference result body for Cricket Match 20-20 (cmatch20):
 * the drawn card (unless a back "1") + "Runs:" rdesc.
 */
export default function Cmatch20ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  return (
    <div className="row row5 align-items-center">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center" style={{ alignItems: "flex-end" }}>
              <div className="casino-result-cards">
                {cards[0] !== "1" && (
                  <div className="casino-result-cards-item">
                    <img src={`${CARDS}/${cards[0]}.png`} alt="" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Runs:</div> <div>{desc[0]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
